import { render, staticRenderFns } from "./appsview_main.vue?vue&type=template&id=00a0971e&scoped=true&"
import script from "./appsview_main.vue?vue&type=script&lang=js&"
export * from "./appsview_main.vue?vue&type=script&lang=js&"
import style0 from "./appsview_main.vue?vue&type=style&index=0&id=00a0971e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a0971e",
  null
  
)

export default component.exports